<template>
  <section class="testimonials">
    <h2 class="testimonials-title">Customer Testimonials</h2>
    <div class="testimonial-content">
      <p class="testimonial-quote">"{{ currentTestimonial.quote }}"</p>
      <p class="testimonial-author">- {{ currentTestimonial.author }}</p>
    </div>
    <div class="testimonial-controls">
      <button @click="prevTestimonial" class="control-button">Prev</button>
      <button @click="nextTestimonial" class="control-button">Next</button>
    </div>
  </section>
</template>

<script>
export default {
  name: "Testimonials",
  data() {
    return {
      testimonials: [
        { quote: "The Banana's Mistress transformed my experience!", author: "John D." },
        { quote: "Unmatched precision and smoothness in every pull.", author: "Sarah L." },
        { quote: "Absolutely the best upgrade to my gear!", author: "Chris P." },
      ],
      currentIndex: 0,
    };
  },
  computed: {
    currentTestimonial() {
      return this.testimonials[this.currentIndex];
    },
  },
  methods: {
    nextTestimonial() {
      this.currentIndex = (this.currentIndex + 1) % this.testimonials.length;
    },
    prevTestimonial() {
      this.currentIndex =
          (this.currentIndex - 1 + this.testimonials.length) % this.testimonials.length;
    },
  },
};
</script>

<style scoped>
.testimonials {
  background-color: #f0f0f0;
  padding: 40px 20px;
  text-align: center;
  border-radius: 8px;
  max-width: 600px;
  margin: 0 auto;
}

.testimonials-title {
  font-size: 1.8em;
  margin-bottom: 20px;
  color: #333;
}

.testimonial-content {
  margin-bottom: 20px;
}

.testimonial-quote {
  font-size: 1.2em;
  font-style: italic;
  color: #666;
}

.testimonial-author {
  font-size: 1em;
  color: #333;
  font-weight: bold;
}

.testimonial-controls {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.control-button {
  padding: 8px 16px;
  font-size: 1em;
  background-color: crimson;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.control-button:hover {
  background-color: darkred;
}
</style>
